import { render, staticRenderFns } from "./PayAuthorityDetailFooter.vue?vue&type=template&id=1e94634d&scoped=true&"
import script from "./PayAuthorityDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./PayAuthorityDetailFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PayAuthorityDetailFooter.vue?vue&type=style&index=0&id=1e94634d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e94634d",
  null
  
)

export default component.exports